export default __webpack_public_path__ + "static/media/zen.3583e59d.png";